export const GMO_ERROR_MSG = {
    '100': 'カード番号必須チェックエラー',
    '101': 'カード番号フォーマットエラー(数字以外を含む)',
    '102': 'カード番号フォーマットエラー(10 - 16 桁の範囲外)',
    '110': '有効期限必須チェックエラー',
    '111': '有効期限フォーマットエラー(数字以外を含む)',
    '112': '有効期限フォーマットエラー(6 又は4 桁以外)',
    '113': '有効期限フォーマットエラー(月が13 以上)',
    '121': 'セキュリティコードフォーマットエラー(数字以外を含む)',
    '122': 'セキュリティコード桁数エラー',
    '131': '名義人フォーマットエラー(半角英数字、一部の記号以外を含む)',
    '132': '名義人フォーマットエラー(51 桁以上)',
    '141': '発行数フォーマットエラー(数字以外を含む)',
    '142': '発行数フォーマットエラー(1 - 10 の範囲外)',
    '160': 'ショップID 必須チェックエラー',
    '161': 'ショップID フォーマットエラー(14 桁以上)',
    '162': 'ショップID フォーマットエラー(半角英数字以外)',
    '170': '公開鍵ハッシュ値必須チェックエラー',
};
